import { render, staticRenderFns } from "./HtTable.vue?vue&type=template&id=70a79c46&scoped=true"
import script from "./HtTable.vue?vue&type=script&lang=js"
export * from "./HtTable.vue?vue&type=script&lang=js"
import style0 from "./HtTable.vue?vue&type=style&index=0&id=70a79c46&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70a79c46",
  null
  
)

export default component.exports